/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SEmbedConfig } from './SEmbedConfig';
import {
    SEmbedConfigFromJSON,
    SEmbedConfigFromJSONTyped,
    SEmbedConfigToJSON,
    SEmbedConfigToJSONTyped,
} from './SEmbedConfig';
import type { SEmbedSessionTokens } from './SEmbedSessionTokens';
import {
    SEmbedSessionTokensFromJSON,
    SEmbedSessionTokensFromJSONTyped,
    SEmbedSessionTokensToJSON,
    SEmbedSessionTokensToJSONTyped,
} from './SEmbedSessionTokens';

/**
 * 
 * @export
 * @interface SEmbedSessionResponse
 */
export interface SEmbedSessionResponse {
    /**
     * S data-access context. Required for full-app sessions.
     * @type {string}
     * @memberof SEmbedSessionResponse
     */
    dataContext?: string;
    /**
     * Saved BI business selection used for a full-app session.
     * @type {string}
     * @memberof SEmbedSessionResponse
     */
    businessContext?: string;
    /**
     * Business IDs used for a full-app session.
     * @type {Array<string>}
     * @memberof SEmbedSessionResponse
     */
    businessIds?: Array<string>;
    /**
     * 
     * @type {SEmbedConfig}
     * @memberof SEmbedSessionResponse
     */
    config: SEmbedConfig;
    /**
     * 
     * @type {SEmbedSessionTokens}
     * @memberof SEmbedSessionResponse
     */
    session: SEmbedSessionTokens;
}

/**
 * Check if a given object implements the SEmbedSessionResponse interface.
 */
export function instanceOfSEmbedSessionResponse(value: object): value is SEmbedSessionResponse {
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('session' in value) || value['session'] === undefined) return false;
    return true;
}

export function SEmbedSessionResponseFromJSON(json: any): SEmbedSessionResponse {
    return SEmbedSessionResponseFromJSONTyped(json, false);
}

export function SEmbedSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SEmbedSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dataContext': json['dataContext'] == null ? undefined : json['dataContext'],
        'businessContext': json['businessContext'] == null ? undefined : json['businessContext'],
        'businessIds': json['businessIds'] == null ? undefined : json['businessIds'],
        'config': SEmbedConfigFromJSON(json['config']),
        'session': SEmbedSessionTokensFromJSON(json['session']),
    };
}

export function SEmbedSessionResponseToJSON(json: any): SEmbedSessionResponse {
    return SEmbedSessionResponseToJSONTyped(json, false);
}

export function SEmbedSessionResponseToJSONTyped(value?: SEmbedSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dataContext': value['dataContext'],
        'businessContext': value['businessContext'],
        'businessIds': value['businessIds'],
        'config': SEmbedConfigToJSON(value['config']),
        'session': SEmbedSessionTokensToJSON(value['session']),
    };
}

